import React from 'react';
import classNames from 'classnames';
import { Input, Icon } from 'antd'


export default class SearchBox extends React.PureComponent {
  static defaultProps = {
    prefixCls: 'ant-input-search',
  };

  constructor(props, context) {
    super(props, context)

    this.input = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      const input = this.input.current;
      if(input && input.input) {
        input.input.focus();
      }
    }, 200);
  }

  onClear = () => {
    const { onClear } = this.props;
    if (onClear) {
      onClear();
    }

    const input = this.input.current;
    if(input && input.input) {
      input.input.focus();
    }
  };

  render() {
    const { className, prefixCls, value, onClear, ...others } = this.props;
    const searchSuffix = value ? (
        <Icon
          className={`${prefixCls}-icon`}
          type="close-circle-o"
          onClick={ this.onClear }
        />
      ) : (
      <Icon
        className={`${prefixCls}-icon`}
        type="search"
      />
    );
    return (
      <Input
        className={classNames(prefixCls, className)}
        ref={ this.input }
        suffix={searchSuffix}
        value={value}
        {...others}
      />
    );
  }
}